import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { messageService } from '../service/messageService';

import { useAppDispatch, useAppSelector } from '../store';
import styles from '../assets/CreatePassword.module.css';
const {
    PASSWORD_REGEX, SUCCESS_NEW_USER_URL, TOKEN_NAME, CREATE_NEW_USER_ENDPOINT, VERIFY_RSVP_CODE, ERROR_URL, UPDATE_PASSWORD_CREATION_STATUS_API_URL
} = require('../helper/application-conf').default;

const {
    PasswordInput, Label, Input, dlsGray03, IconCopy, GlyphCheck, GlyphClose, GlyphInfo, ButtonPrimary, dlsRed, dlsGreen, Alert, Tooltip, TooltipButton, dlsBrightBlue,
    ButtonSecondary, Checkbox, PhoneInput, ProgressCircle
} = require('@americanexpress/dls-react');
import newUserStyles from '../assets/NewUser.module.css';
import { userIdErrorsModel, validateNewUserForm, validateUserId } from '../helper/validator';
import { NewUserState, newUserActions } from '../store/newUserState';
import MessageBanner from './MessageBanner';
import axios from 'axios';
import useScript from '../hooks/useScript';
import { OneIdentityService } from '../service/oneIdentityService';
import { axiosBuyerPassthrough, axiosOneId } from '../hooks/axios';
import { StorageService } from '../helper/storage-service';
import jwt from 'jwt-decode';


const NewUser = () => {
    const { t } = useTranslation();
    const appDispatch = useAppDispatch();
    const navigate = useNavigate();
    const newUser: NewUserState = useAppSelector((state) => state.newuser);
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [passwordStatus, setPasswordStatus] = useState('default');
    const [passwordUserIdStatus, setPasswordUserIdStatus] = useState('default');
    const [passwordSpaces, setPasswordSpaces] = useState('default');
    const [passwordLengthCheck, setPasswordLengthCheck] = useState('default');
    const [securityCodeLengthCheck, setsecurityCodeLengthCheck] = useState('default');
    const [passwordCharacterCheck, setPasswordCharacterCheck] = useState('default');
    const [userIdErrors, setUserIdErrors] = useState(userIdErrorsModel);
    const appState = useAppSelector((state) => state);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [displayMiddleName, setDisplayMiddleName] = useState(true);
    const isFormValid = useRef(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [userUUID, setuserUUID] = useState('');
    const [userExists, setUserExists] = useState(false);
    const [loading, setLoading] = useState(false);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const oneIdentityService = new OneIdentityService();
    const storage = new StorageService();
    const SITENAME = window.location.pathname.split('/')[2];

    const updateField = useCallback((field: string, value: string, e: any = undefined) => {
        if (e && e.target.getAttribute('numeric') === 'true' && e.target.value.match(/\D/)) {
            return;
        }
        appDispatch(newUserActions.setNewUser({
            ...newUser,
            [field]: value,
        }));
    }, [newUser, appDispatch]);

    useEffect(() => {
        messageService.sendstepperToggle(false);
        if(storage.getSession(TOKEN_NAME)) {
            const token = storage.getSession(TOKEN_NAME) as any;
            const parsedToken = JSON.parse(token);
            const accessToken = parsedToken.accessToken;
            const decodedAccessToken = jwt(accessToken) as any;
            const phone = JSON.parse(decodedAccessToken.phone)
            appDispatch(newUserActions.setNewUser({
                ...newUser,
                'firstName': decodedAccessToken.given_name,
                'lastName': decodedAccessToken.family_name,
                'email': decodedAccessToken.email,
                'cellPhone': phone.cellphone
            }));
        }
        else {
            verifyRsvpCode()
        }

    }, []);

    const verifyRsvpCode = useCallback(async ()=> {
        setLoading(true)
        const SITE_NAME = window.location.pathname.split('/')[2];
        const RSVP_CODE = urlParams.get('rsvpCode') || '';
        await axios.get(
            `${VERIFY_RSVP_CODE}/${SITE_NAME}/${RSVP_CODE}`
        ).then((getResponse) => {
            if (getResponse.status == 200 && getResponse.data) {
                const data = getResponse.data.body.data;
                setuserUUID(data.userId)
                appDispatch(newUserActions.setNewUser({
                    ...newUser,
                    'firstName': data.firstName,
                    'lastName': data.lastName,
                    'email': data.userName,
                    'cellPhone': data.cellPhone
                }));

                if (data.expired) // Expired screen
                {
                    const errorText = { message: "", mobileVerificationStatus: "" };
                    navigate(ERROR_URL, { state: { errorText } });
                }
            }
            else {
                navigate(ERROR_URL);
            }
            setLoading(false);
        }, (error) => {
            setLoading(false);
            if (error.response && error.response.status === 400 && error.response.data) {
                const errorText = { message: error.response.data, mobileVerificationStatus: "" };
                navigate(ERROR_URL, { state: { errorText } });
            } else {
                navigate(ERROR_URL);
            }
        });
    },[]);


    const confirmPassword = useCallback((passwordConf: any) => {
        setPasswordConfirmation(passwordConf )
    }, [newUser]);

    useEffect(() => {
        if (password && passwordConfirmation) {
            if (password === passwordConfirmation) {
                setPasswordStatus('success');
            }
            else {
                setPasswordStatus('error');
            }
        }

    }, [password, passwordConfirmation])

    useEffect(() => {
        if(appState.newuser.password) {
            if (appState.newuser.password.toLocaleLowerCase().includes(appState.newuser.userId.toLocaleLowerCase())) {
                setPasswordUserIdStatus('error');
            }
            else {
                setPasswordUserIdStatus('success');
            }
        }
    },[appState.newuser.userId, appState.newuser.password]);

    const confirmPasswordSpaces = useCallback((event: string) => {
        if (/\s/g.test(event)) {
            setPasswordSpaces('error');
            return true;
        }
        setPasswordSpaces('success');
        return false;
    }, [password]);

    const checkPasswordLength = useCallback((pswd: string) => {
        if (pswd.length < 8) {
            setPasswordLengthCheck('error');
        } else {
            setPasswordLengthCheck('success');
        }
    }, []);

    const checkSecurityCodeLength = useCallback((code: string) => {
        if (code.length < 6 || code.length > 9) {
            setsecurityCodeLengthCheck('error');
        } else {
            setsecurityCodeLengthCheck('success');
        }
    }, []);

    const checkPasswordCharacters = useCallback((pswd: string) => {
        const regex = PASSWORD_REGEX;
        if (!pswd.match(regex)) {
            setPasswordCharacterCheck('error');
        } else {
            setPasswordCharacterCheck('success');
        }
    }, []);

    const handleChange = (e: any) => {
        const currentErrors: any = validateUserId({ userId: e });
        setUserIdErrors(currentErrors)
    };

    const invalidFields = useCallback((submitting = false) => {
        if (!hasSubmitted && !submitting) {
            return [];
        }
        const invalid = validateNewUserForm(newUser);
        return invalid;
    }, [newUser, hasSubmitted]);


    const fieldStatus = useCallback((field: any) => {
        if (invalidFields().includes(field)) {
            return 'error';
        }
        return 'default';
    }, [invalidFields]);

    const validationStatus = useCallback(() => {
        if (!userIdErrors.userIdLengthErrors.error && !userIdErrors.oneLetteError.error && !userIdErrors.specialCharacterError.error
            && passwordUserIdStatus !== 'error'
            && passwordLengthCheck !== 'error' && passwordCharacterCheck !== 'error'
            && passwordSpaces !== 'error') {
            isFormValid.current = true;
        }
        else {
            isFormValid.current = false;
        }
    }, [hasSubmitted, userIdErrors, passwordUserIdStatus, passwordLengthCheck, passwordCharacterCheck, passwordSpaces, passwordStatus]);

    const submit = useCallback(async () => {
        setHasError(false);
        setHasSubmitted(true);
        validationStatus()
        const RSVP_CODE = urlParams.get('rsvpCode') || '';
        if (invalidFields(true).length === 0 && isFormValid.current) {
            const payload: any = {
                "userId": newUser.userId,
                "password": newUser.password,
                "firstName": newUser.firstName,
                "lastName": newUser.lastName,
                "email": newUser.email,
                "mobileNumber": newUser.cellPhone,
                "securityCode": newUser.code,
                "siteName": SITENAME,
                "rsvpCode": RSVP_CODE
            }

            await axiosOneId.post(`${window.location.origin}/auth/api${CREATE_NEW_USER_ENDPOINT}`, payload).then((response) => {
                if (response.status == 201 && response.data) {
                    navigate(SUCCESS_NEW_USER_URL,{ state: { profileCreationSuccess: true }});
                    setHasError(false);
                    setUserExists(false);
                }
                else {
                    window.scrollTo(0, 0)
                    setHasError(true);
                    const genericError = t('genericError');
                    setErrorMessage(genericError);
                }
            }, (error) => {
                if (error.response && error.response.data) {
                    setErrorMessage(error.response.data.detail)
                    if(error.response.data.code === 'UE005') {
                       const credentialsError = t('user_info.password_check')
                       setErrorMessage(credentialsError);
                    }
                    else if (error.response.data.code === 'UE004') {
                        setUserExists(true);
                    }
                    else if (error.response.data.code === 'UE002') {
                        setErrorMessage(error.response.data.detail);
                    }
                    else {
                        const genericError = t('genericError');
                        setErrorMessage(genericError);
                    }
                }
                window.scrollTo(0, 0)
                setHasError(true);
            });

        }
    }, [invalidFields, validationStatus]);

    const CheckboxContent = () => {
        return <div dangerouslySetInnerHTML={
            {
                __html: `<p style="display:inline">${t('create_password.privacy_statement')} <p style="display:inline"> <a class="text-underline" href='https://www.americanexpress.com/us/company/privacy-center/online-privacy-disclosures/' 
       target="_blank">Privacy Statement</a></p>.</p>`}
        } />;
    }


    return (
        <Fragment>
            {loading ? (
                <div className="row text-align-center pad-4-t flex flex-justify-center">
                    <ProgressCircle size="lg" />
                </div>
            ) : (
                <div className='margin-2-b'>
                    <MessageBanner type="warning" messageText={errorMessage} showMessage={hasError} classes="col-md-offset-1 col-md-10" />
                    <div className={`container ${newUserStyles.borders} margin-2-b`}></div>
                    <div>
                        <h5 className={`container heading-5 pad-3-tb pad-0-l dls-white ${newUserStyles.customHeaderStyle} ${hasError ? newUserStyles.customHeaderStyleTop2 : newUserStyles.customHeaderStyleTop1}`}>{t('create_password.header_1')}</h5>
                        <div className={`container dls-white-bg ${newUserStyles.customPadLeft1}`}>
                            <div className="row pad-4-t">
                                <div className="col-md-12">
                                    <h4 className={`heading-4 pad-1-t pad-3-b heading-4 dls-deep-blue`}>{t('create_password.setup_creds')}</h4>
                                    <span className="heading-3 pad-2-t">
                <Label id='email-id-label'>
                  <span>{t('create_password.email_address')}</span>
                  <Tooltip aria-labelledby='email-id-label' info={true} placement="right" triggerElement={<TooltipButton info={true} icon={<GlyphInfo theme={dlsBrightBlue} size="lg" />} />}>
                    <p className="body-1 pad-1-t">{t('create_password.user_id_tooltip')}</p>
                  </Tooltip>
                </Label>
                </span>

                                    <p className="body-3">{newUser.email}</p>
                                </div>
                            </div>
                            <div className="row pad-3-t">
                                <div className="col-md-4">
                                    <Label id="user-id-label" htmlFor="user-id-input">
                                        {t('create_password.user_id_1')}
                                    </Label>
                                    <p className={`pad-1-t body-1 dls-gray-05`}>{t('create_password.user_id_hint')}</p>
                                    <Input id="user-id-input" maxLength={20} value={newUser.userId} onChange={(e: any) => { updateField('userId', e.target.value); handleChange(e.target.value); }} required={true} />
                                    {(fieldStatus('userID-required') === 'error')
                                        && <Alert className="pad-1-t">{t('errors.userid_required')}</Alert>}
                                    {(userExists)
                                        && <Alert className="pad-1-t">{t('create_password.user_id_exists')}</Alert>}
                                    {(userIdErrors.userIdLengthErrors.error || userIdErrors.oneLetteError.error || userIdErrors.specialCharacterError.error)
                                        && <Alert className="pad-1-t">{t('errors.userid_invalid_1')}</Alert>}
                                </div>

                                <div className={`col-md-4 ${newUserStyles.customPadTop2}`}>
                                    <div className="flex flex-start">
                                        {userIdErrors && userIdErrors.userIdLengthErrors.default && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {userIdErrors && userIdErrors.userIdLengthErrors.success && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {userIdErrors && userIdErrors.userIdLengthErrors.error && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('user_info.user_id_length')}</p>
                                    </div>
                                    <div className="flex flex-start">
                                        {userIdErrors && userIdErrors.oneLetteError.default && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {userIdErrors && userIdErrors.oneLetteError.success && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {userIdErrors && userIdErrors.oneLetteError.error && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('user_info.at_least_one_letter')}</p>
                                    </div>
                                    <div className="flex flex-start">
                                        {userIdErrors && userIdErrors.specialCharacterError.default && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {userIdErrors && userIdErrors.specialCharacterError.success && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {userIdErrors && userIdErrors.specialCharacterError.error && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('user_info.no_special_character')}</p>
                                    </div>
                                </div>

                            </div>
                            <div className="row pad-3-t">
                                <div className="col-md-4">
                                    <Label id="password-input-label" htmlFor="password-input">{t('create_password.password')}</Label>
                                    <p className={`pad-1-t body-1 dls-gray-05`}>{t('create_password.password_hint')}</p>
                                    <PasswordInput
                                        id="password-input"
                                        value={newUser.password}
                                        maxLength={20}
                                        onChange={(event: any) => {
                                            updateField('password', event.target.value);
                                            setPassword(event.target.value);
                                            checkPasswordLength(event.target.value);
                                            checkPasswordCharacters(event.target.value);
                                            confirmPasswordSpaces(event.target.value)
                                        }
                                        }
                                    />
                                    {(fieldStatus('password-required') === 'error')
                                        && <Alert className="pad-1-t">{t('errors.password_required')}</Alert>}
                                    {(fieldStatus('password-invalid') === 'error')
                                        && <Alert className="pad-1-t">{t('errors.password_invalid')}</Alert>}
                                    {(passwordUserIdStatus == 'error' || passwordLengthCheck == 'error' || passwordCharacterCheck == 'error' || passwordSpaces == 'error')
                                        && <Alert className="pad-1-t">{t('errors.password_invalid_1')}</Alert>}
                                </div>

                                <div className={`col-md-4 ${newUserStyles.customPadTop2}`}>
                                    <div className="flex flex-start">
                                        {passwordUserIdStatus === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {passwordUserIdStatus === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {passwordUserIdStatus === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('create_password.password_requirements_5')}</p>
                                    </div>
                                    <div className="flex flex-start">
                                        {passwordLengthCheck === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {passwordLengthCheck === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {passwordLengthCheck === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('create_password.password_requirements_6')}</p>
                                    </div>
                                    <div className="flex flex-start">
                                        {passwordCharacterCheck === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {passwordCharacterCheck === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {passwordCharacterCheck === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('create_password.password_requirements_3')}</p>
                                    </div>
                                    <div className="flex flex-start">
                                        {passwordSpaces === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {passwordSpaces === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {passwordSpaces === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('create_password.password_requirements_4')}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row pad-2-t">
                                <div className="col-md-4">
                                    <Label id="confirm-password-input-label" htmlFor="confirm-password-input">{t('create_password.confirm_password')}</Label>
                                    <PasswordInput
                                        id="confirm-password-input"
                                        value={newUser.confirmPassword}
                                        maxLength={20}
                                        onChange={(event: any) => {
                                            updateField('confirmPassword', event.target.value);
                                            setPasswordConfirmation(event.target.value);
                                            confirmPassword(event.target.value);
                                        }
                                        }
                                    />
                                    {(fieldStatus('confirmPassword-required') === 'error')
                                        && <Alert className="pad-1-t">{t('errors.confirm_password_required')}</Alert>}
                                    {passwordStatus === 'error'
                                        && <Alert status="error" className="pad-1-t">{t('errors.password_confirmation')}</Alert>}
                                </div>

                                <div className="col-md-4 pad-3-t">
                                    <div className="flex flex-start">
                                        {passwordStatus === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGray03} />}
                                        {passwordStatus === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsGreen} />}
                                        {passwordStatus === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-r`} theme={dlsRed} />}
                                        <p className="body-1">{t('create_password.password_match')}</p>
                                    </div>
                                </div>
                            </div>

                            <form>
                                <h4 className={`heading-4 pad-4-t heading-4 dls-deep-blue`}>{t('create_password.secure_account')}</h4>
                                <p className='body-1'>{t('create_password.secure_account_tooltip')}</p>

                                <div className="row pad-t">
                                    <div className="col-md-offset-0 col-md-4">
                                        <Label id="first-name-label" htmlFor="first-name-input">
                                            {t('user_info.first_name')}
                                        </Label>
                                        <Input id="first-name-input" maxLength={19} value={newUser.firstName} onChange={(e: any) => updateField('firstName', e.target.value)} required={true} disabled={true} />
                                        {(fieldStatus('firstName-required') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.firstname_required_field')}</Alert>}
                                        {(fieldStatus('firstName-invalid') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.invalid_fname')}</Alert>}
                                    </div>


                                    <div className="col-md-4">
                                        <Label id="last-name-label" htmlFor="last-name-input">
                                            {t('user_info.last_name')}
                                        </Label>
                                        <Input id="last-name-input" maxLength={19} value={newUser.lastName} onChange={(e: any) => updateField('lastName', e.target.value)} required={true} disabled={true} />
                                        {(fieldStatus('lastName-required') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.lastname_required_field')}</Alert>}
                                        {(fieldStatus('lastName-invalid') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.invalid_lname')}</Alert>}
                                    </div>
                                </div>

                                {displayMiddleName && (
                                    <div className="row pad-t">
                                        <div className="col-md-4">
                                            <Label id="middle-name-label" htmlFor="middle-name-input">
                                                {t('user_info.middle_name')}
                                            </Label>
                                            <Input id="middle-name-input" maxLength={25} value={newUser.middleName} onChange={(e: any) => updateField('middleName', e.target.value)} />
                                            {(fieldStatus('middleName-invalid') === 'error')
                                                && <Alert className="pad-1-t">{t('errors.middle_name_invalid')}</Alert>}
                                        </div>
                                    </div>
                                )}

                                <div className="row pad-t">
                                    <div className="col-md-offset-0 col-md-4">
                                        <Label id="mobile-number-label" htmlFor="business-phone-input">
                                            {t('create_password.mobile_number')}
                                            <span>
                      <Tooltip aria-labelledby="mobile-number-label" info={true} placement="right" triggerElement={<TooltipButton info={true} icon={<GlyphInfo theme={dlsBrightBlue} size="lg" />} />}>
                        <p className="body-1 pad-1-t">{t('create_password.mobile_number_tooltip')}</p>
                      </Tooltip>
                    </span>
                                        </Label>
                                        <PhoneInput id="business-phone-input" value={newUser.cellPhone} onChange={(e: any) => updateField('cellPhone', e.target.value)} phoneFormat="(###) ###-####" />
                                        {(fieldStatus('cellPhone-required') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.mobile_required')}</Alert>}
                                        {(fieldStatus('cellPhone-invalid') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.mobile_invalid')}</Alert>}
                                    </div>

                                    <div className="col-md-4">
                                        <Label id="security-code-label" htmlFor="security-code-input">
                                            {t('create_password.security_code')}
                                            <span>
                          <Tooltip aria-labelledby="security-code-label" info={true} placement="right" triggerElement={<TooltipButton info={true} icon={<GlyphInfo theme={dlsBrightBlue} size="lg" />} />}>
                            <p className="body-1 pad-1-t">{t('create_password.secure_account_tooltip')}</p>
                          </Tooltip>
                        </span>
                                        </Label>
                                        <PasswordInput
                                            id="security-code-input"
                                            value={newUser.code}
                                            hideButton= {true}
                                            required={true}
                                            type={'number'}
                                            onChange={(event: any) => {
                                                updateField('code', event.target.value)
                                                checkSecurityCodeLength(event.target.value)
                                            }
                                            }
                                        />
                                        {(fieldStatus('securityCode-required') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.security_code_required')}</Alert>}
                                        {(fieldStatus('securityCode-invalid') === 'error')
                                            && <Alert className="pad-1-t">{t('errors.security_code_invalid')}</Alert>}

                                        <div>
                                            <div className="flex flex-start">
                                                {securityCodeLengthCheck === 'default' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-1-r`} theme={dlsGray03} />}
                                                {securityCodeLengthCheck === 'success' && <GlyphCheck className={`${styles.glyphOpticalAdjustment} pad-1-r`} theme={dlsGreen} />}
                                                {securityCodeLengthCheck === 'error' && <GlyphClose className={`${styles.glyphOpticalAdjustment} pad-1-r`} theme={dlsRed} />}
                                                <p className="body-1">{t('create_password.security_code_hint_1')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div className="pad-1-tb">
                                <Checkbox id="checkbox" checked={newUser.privacyStatement} label={<CheckboxContent />} onChange={(e: any) => updateField('privacyStatement', e.target.checked)} />
                                {(fieldStatus('privacyStatement-required') === 'error')
                                    && <Alert className="pad-1-t">{t('errors.privacy_statement_required')}</Alert>}
                            </div>

                            <div className="pad-4-tb">
                                <div className="flex flex-align-center">
                                    <ButtonPrimary size="md" onClick={submit} id="create-password-button">{t('create_password.create_account')}</ButtonPrimary>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default NewUser;
